// Event bus for permission changes
class PermissionEventBus {
  constructor() {
    this.listeners = new Set();
  }

  // Subscribe to permission change events
  subscribe(callback) {
    console.log('📢 PermissionEventBus: New subscriber added, total listeners:', this.listeners.size + 1);
    this.listeners.add(callback);
    return () => {
      this.listeners.delete(callback);
      console.log('📢 PermissionEventBus: Subscriber removed, remaining listeners:', this.listeners.size);
    };
  }

  // Emit permission change event
  notifyPermissionChange(userId, permissions) {
    console.log('📢 PermissionEventBus: Notifying permission change for user:', userId, 'listeners:', this.listeners.size);
    this.listeners.forEach(callback => {
      try {
        callback({ userId, permissions });
      } catch (error) {
        console.error('Error in permission change callback:', error);
      }
    });
  }

  // Notify that any user's permissions were updated
  notifyUserPermissionsUpdated(userId) {
    console.log('📢📢📢 PermissionEventBus: Broadcasting user permissions updated:', userId);
    console.log('📢 PermissionEventBus: Active listeners:', this.listeners.size);
    
    let callbackCount = 0;
    this.listeners.forEach(callback => {
      try {
        callbackCount++;
        console.log(`📢 PermissionEventBus: Calling listener ${callbackCount}/${this.listeners.size}`);
        callback({ userId, type: 'permissions_updated' });
      } catch (error) {
        console.error(`❌ PermissionEventBus: Error in callback ${callbackCount}:`, error);
      }
    });
    
    console.log(`✅ PermissionEventBus: Notified ${callbackCount} listeners`);
  }
}

// Create singleton instance
const permissionEventBus = new PermissionEventBus();

// Also expose as window event for cross-tab communication
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === 'permissions_updated') {
      try {
        const data = JSON.parse(e.newValue);
        permissionEventBus.notifyUserPermissionsUpdated(data.userId);
      } catch (error) {
        console.error('Error parsing permission update event:', error);
      }
    }
  });
}

export default permissionEventBus;

